import { CompanyDetailsForm } from '@module/communication/model/CompanyDetailsForm';
import { ProfileResponse } from '@module/profile/model/ProfileResponse';
import { CompanyResponse } from '../../../types';
import { mainRestApi } from '../rest-api';

export const accountApi = mainRestApi.injectEndpoints({
  endpoints: (build) => ({
    acceptTermsCondition: build.mutation<
      ProfileResponse,
      { accepted: boolean; documentVersion?: string | undefined }
    >({
      query: ({ accepted, documentVersion = '1.0' }) => ({
        url: '/secured/account/accept-terms-and-conditions',
        method: 'POST',
        data: {
          accepted,
          documentVersion
        }
      })
    }),
    loadCompanyInfo: build.query<CompanyResponse, void>({
      query: () => ({
        url: '/secured/account/company/load',
        method: 'GET'
      }),
      providesTags: (res) => (res ? ['AGENT_COMPANY_DETAILS'] : [])
    }),
    updateCompanyInfo: build.mutation<CompanyResponse, CompanyDetailsForm>({
      query: (companyDetailsForm) => ({
        url: '/secured/account/company/save',
        method: 'POST',
        data: companyDetailsForm
      }),
      invalidatesTags: (res) =>
        res ? ['AGENT_COMPANY_DETAILS', 'AGENT_PROFILE'] : []
    })
  })
});

export const {
  useAcceptTermsConditionMutation,
  useLoadCompanyInfoQuery,
  useLazyLoadCompanyInfoQuery,
  useUpdateCompanyInfoMutation
} = accountApi;
